import axios from 'axios'

if (process.env.NODE_ENV === 'production') {
  // 干一些线上才要做的事情
  axios.defaults.baseURL = 'https://www.aosom.com.cn/zp/api'
}
if (process.env.NODE_ENV === 'development') {
  // 干一些测试时不可告人的事情
  axios.defaults.baseURL = '/api'
}
